<rappider-spin size="large"
               [spinning]="loading">
  <section>

    <rappider-title-toolbar [mainTitle]="mainTitle"
                            [options]="title"
                            [titleBarActionButtons]="titleBarActionButtons"
                            [titleBarSwitchSettings]="powerSwitchConfig"
                            [isSwitchVisible]="false"
                            (switchToggled)="onSwitchToggled($event)"
                            (titleBarActionButtonClick)="onTitleBarActionButtonClick($event)"></rappider-title-toolbar>

    <ng-template #iframeTemplate>
      <ng-container
                    *ngIf="(displayedBuild?.status === DeployStatus.Successful || displayedBuild?.status === DeployStatus.Queued || displayedBuild?.status === DeployStatus.InProgress) && (powerSwitchConfig?.defaultValue !== false) && (powerSwitchConfig?.loading !== true) && isThereSuccessfulDeploy && serverInfoAvailable">
        <div class="animation live-preview-in-progress-content-area">
          <rappider-alert class="live-preview-fail-info-alert"
                          [showIcon]="true"
                          type="info"
                          [description]="displayedBuild?.status === DeployStatus.Successful ? displayedBuild?.version_branch ? 'You are currently viewing version '+displayedBuild?.version_branch+'.' : 'You are currently viewing last version.' : 'You are currently previewing version '+displayedPreviousBuild?.version_branch+', deployed on '+displayedPreviousBuild?.end_time+'.'"></rappider-alert>
        </div>
        <div class="live-preview-iframe">
          <iframe [src]="frontendURL | safeUrl"
                  [ngClass]="!isDeploymentLogVisible ? 'full-witdh-preview-area' : ''"
                  class="live-preview"
                  #iframe
                  scrolling="yes"
                  frameborder="0"
                  (load)="onIFrameContentLoaded()"></iframe>
        </div>
      </ng-container>
      <ng-container
                    *ngIf="(displayedBuild?.status === DeployStatus.Successful) && isThereSuccessfulDeploy && !serverInfoAvailable">
        <div class="animation live-preview-in-progress-content-area">
          <rappider-alert class="live-preview-fail-info-alert"
                          [showIcon]="true"
                          type="info"
                          title="Server if offline."
                          description="You're seeing this warning because the server is currently offline.
                          You can click the Deploy button to deploy your source code to the server.
                          Once the deployment is complete, you’ll be able to preview your project."></rappider-alert>
        </div>
      </ng-container>
      <ng-container
                    *ngIf="(displayedBuild?.status === DeployStatus.Successful || displayedBuild?.status === DeployStatus.Queued || displayedBuild?.status === DeployStatus.InProgress) && isThereSuccessfulDeploy && serverInfoAvailable && (powerSwitchConfig?.defaultValue !== false) && (powerSwitchConfig?.loading !== false)">
        <div class="animation live-preview-in-progress-content-area">
          <rappider-alert class="live-preview-fail-info-alert"
                          [showIcon]="true"
                          type="info"
                          title="The Server Startup Procedure is in Progress"
                          description="The server is currently undergoing initialization. We are actively monitoring the process and will provide updates once it is successfully completed"></rappider-alert>
        </div>
      </ng-container>
      <ng-container
                    *ngIf="(displayedBuild?.status === DeployStatus.Successful || displayedBuild?.status === DeployStatus.Queued || displayedBuild?.status === DeployStatus.InProgress) && isThereSuccessfulDeploy && serverInfoAvailable && (powerSwitchConfig?.defaultValue !== true) && (powerSwitchConfig?.loading !== false)">
        <div class="animation live-preview-in-progress-content-area">
          <rappider-alert class="live-preview-fail-info-alert"
                          [showIcon]="true"
                          type="info"
                          title="The Server Shutdown Procedure is in Progress"
                          description="The server is being shut down. Updates will follow once complete"></rappider-alert>
        </div>
      </ng-container>
      <ng-container
                    *ngIf="(displayedBuild?.status === DeployStatus.Successful) && isThereSuccessfulDeploy && (powerSwitchConfig?.defaultValue === false) && (powerSwitchConfig?.loading !== true)">
        <div class="animation live-preview-in-progress-content-area">
          <rappider-alert class="live-preview-fail-info-alert"
                          [showIcon]="true"
                          type="info"
                          title="Server power is off"
                          description="Please turn on the power to view the deployment"></rappider-alert>
        </div>
      </ng-container>
    </ng-template>

    <div class="live-preview-wrapper">
      <ng-container [ngSwitch]="displayedBuild?.status">
        <div class="live-preview-content-area">

          <ng-container *ngSwitchCase="DeployStatus.InProgress">
            <div *ngIf="displayedBuild?.status === DeployStatus.InProgress && (!isThereSuccessfulDeploy || !serverInfoAvailable || ((powerSwitchConfig?.defaultValue === false) && (powerSwitchConfig?.loading === false)))"
                 class="animation live-preview-in-progress-content-area">
              <rappider-alert class="live-preview-fail-info-alert"
                              [showIcon]="true"
                              type="info"
                              title="Deployment in Progress"
                              description="The deployment is in progress. Please wait a moment while it completes."></rappider-alert>
              <div class="live-preview-animation-player-wrapper-in-progress">
                <rappider-lottie-player [options]="inProgressAnimationConfig"
                                        [width]="'100%'"
                                        [height]="'100%'"></rappider-lottie-player>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="DeployStatus.NotStarted">
            <div *ngIf="displayedBuild?.status === DeployStatus.NotStarted"
                 class="animation live-preview-in-progress-content-area">
              <rappider-alert class="live-preview-fail-info-alert"
                              [showIcon]="true"
                              type="info"
                              title="Deployment Not Started"
                              description="The deployment process has not been initiated. Please check the required steps and try again."></rappider-alert>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="DeployStatus.Queued">
            <div *ngIf="displayedBuild?.status === DeployStatus.Queued  && (!isThereSuccessfulDeploy || !serverInfoAvailable || ((powerSwitchConfig?.defaultValue === false) && (powerSwitchConfig?.loading === false)))"
                 class="animation live-preview-in-progress-content-area">
              <rappider-alert class="live-preview-fail-info-alert"
                              [showIcon]="true"
                              type="info"
                              title="Waiting in Queue"
                              description="You are currently in the queue. Your request will be processed as soon as it reaches the front."></rappider-alert>
              <div class="live-preview-animation-player-wrapper-queued">
                <rappider-lottie-player [options]="queuedAnimationConfig"
                                        [width]="'100%'"
                                        [height]="'100%'"></rappider-lottie-player>
              </div>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="DeployStatus.Failure">
            <rappider-alert class="live-preview-fail-info-alert"
                            [showIcon]="true"
                            type="info"
                            title="Deploy Failed"
                            description="An error occurred during the deploy process. Please try again. If the issue persists, please contact the support team for assistance."></rappider-alert>
          </ng-container>

          <ng-container [ngTemplateOutlet]="iframeTemplate"></ng-container>
        </div>
      </ng-container>

      <section class="log-area"
               *ngIf="isDeploymentLogVisible">
        <ng-container [ngTemplateOutlet]="deploymentInfoTemplate"
                      [ngTemplateOutletContext]="{
                      data: {
                        build: displayedBuild,
                        timestamp: displayedBuild?.end_time
                      }
                    }"></ng-container>
        <!-- SET LATEST_BUILD AS 'build' VARIABLE IN TEMPLATE -->
        <ng-template #deploymentInfoTemplate
                     let-build="data.build"
                     let-timestamp="data.timestamp">
          <div class="deployment-log-body">
            <div class="log-tabs">
              <nz-tabset class="tabset-overflow"
                         nzSize="small">
                <nz-tab nzTitle="Build Info">
                  <div class="deploy-time-and-version">
                    <div class="build-info-item">
                      <strong>
                        Status:
                      </strong>
                      <div class="icon-text">
                        <div>
                          {{setDeployStatusIcon(build?.status).text}}
                        </div>
                        <rappider-icon [name]="setDeployStatusIcon(build?.status).icon"></rappider-icon>
                      </div>
                    </div>

                    <div class="build-info-item">
                      <strong>
                        Version:
                      </strong>
                      {{build?.version_branch ?? '-'}}
                    </div>

                    <div class="build-info-item">
                      <strong>
                        Started at:
                      </strong>
                      {{ build?.start_time ? moment(build?.start_time).calendar() : '-' }}
                    </div>

                    <div class="build-info-item">
                      <strong>
                        Ended at:
                      </strong>
                      {{ build?.end_time ? moment(build?.end_time).calendar() : '-' }}
                    </div>

                    <div class="build-info-item"
                         *ngIf="build?.index_created_date">
                      <strong>
                        Files Deployed At:
                      </strong>
                      {{ build?.index_created_date ? (build?.index_created_date | formatDate) : '-' }}
                    </div>

                    <div class="build-steps">
                      <strong>
                        Build & Deploy Steps
                      </strong>
                      <hr class="build-steps-ruler">
                      <rappider-timeline *ngIf="timelineItems?.length"
                                         [items]="timelineItems"
                                         [reverseTreeItem]="true"
                                         [editorOptions]="editorConfig"
                                         [isPreviewEnabled]="true"
                                         [modalTitle]="'Deploy Error Details'"></rappider-timeline>
                      <div *ngIf="!timelineItems?.length && !(displayedBuild?.status === DeployStatus.NotStarted)">
                        Loading <i class="fa-duotone fa-gear fa-spin"></i>
                      </div>
                      <div *ngIf="!timelineItems?.length && displayedBuild?.status === DeployStatus.NotStarted">
                        Not Started <i class="fa-regular fa-hexagon-exclamation"></i>
                      </div>
                    </div>
                  </div>
                </nz-tab>
              </nz-tabset>
            </div>
          </div>
        </ng-template>
      </section>
    </div>
  </section>

  <!-- <rappider-no-social-media-shared *ngIf="!isSocialMediaShared"></rappider-no-social-media-shared> -->
</rappider-spin>
